export default function ListIcon({
  width,
  height,
}: {
  width?: number;
  height?: number;
}) {
  return (
    <svg
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 53 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1346_2746)">
        <path
          d="M36.4375 38.7461H23.1875V42.0586H36.4375V38.7461Z"
          fill="currentColor"
        />
        <path
          d="M19.875 38.7461H16.5625V42.0586H19.875V38.7461Z"
          fill="currentColor"
        />
        <path
          d="M36.4375 30.4648H23.1875V33.7773H36.4375V30.4648Z"
          fill="currentColor"
        />
        <path
          d="M19.875 30.4648H16.5625V33.7773H19.875V30.4648Z"
          fill="currentColor"
        />
        <path
          d="M36.4375 22.1836H23.1875V25.4961H36.4375V22.1836Z"
          fill="currentColor"
        />
        <path
          d="M19.875 22.1836H16.5625V25.4961H19.875V22.1836Z"
          fill="currentColor"
        />
        <path
          d="M41.4062 8.93359H36.4375V7.27734C36.4375 6.39881 36.0885 5.55627 35.4673 4.93505C34.8461 4.31384 34.0035 3.96484 33.125 3.96484H19.875C18.9965 3.96484 18.1539 4.31384 17.5327 4.93505C16.9115 5.55627 16.5625 6.39881 16.5625 7.27734V8.93359H11.5938C10.7152 8.93359 9.87267 9.28259 9.25146 9.9038C8.63024 10.525 8.28125 11.3676 8.28125 12.2461V47.0273C8.28125 47.9059 8.63024 48.7484 9.25146 49.3696C9.87267 49.9908 10.7152 50.3398 11.5938 50.3398H41.4062C42.2848 50.3398 43.1273 49.9908 43.7485 49.3696C44.3698 48.7484 44.7188 47.9059 44.7188 47.0273V12.2461C44.7188 11.3676 44.3698 10.525 43.7485 9.9038C43.1273 9.28259 42.2848 8.93359 41.4062 8.93359ZM19.875 7.27734H33.125V13.9023H19.875V7.27734ZM41.4062 47.0273H11.5938V12.2461H16.5625V17.2148H36.4375V12.2461H41.4062V47.0273Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1346_2746">
          <rect
            width="53"
            height="53"
            fill="white"
            transform="translate(0 0.652344)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
